'use client';

import React from 'react';
import SlideWrapper from '../SlideWrapper';
import { Video, Image, FileText, Share2 } from 'lucide-react';

interface Props {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
}

const mediaItems = [
{
  icon: <Video size={22} className="text-[#4caf7d]" />,
  title: 'Video recap chương trình',
  desc: 'Video tổng kết chuyên nghiệp, cảm xúc — sẵn sàng đăng fanpage trường',
  format: 'MP4 · 2–3 phút',
  color: '#4caf7d'
},
{
  icon: <Image size={22} className="text-[#e8a030]" />,
  title: 'Hình ảnh chất lượng cao',
  desc: 'Bộ ảnh đầy đủ từ hoạt động, lễ trao chứng nhận, và khoảnh khắc đặc biệt',
  format: 'JPG · 100+ ảnh',
  color: '#e8a030'
},
{
  icon: <FileText size={22} className="text-[#a8d87a]" />,
  title: 'Tư liệu truyền thông',
  desc: 'Bài viết mẫu, hashtag, và kit truyền thông đầy đủ để nhà trường đăng ngay',
  format: 'PDF · Canva Kit',
  color: '#a8d87a'
},
{
  icon: <Share2 size={22} className="text-[#f5c96a]" />,
  title: 'Nội dung sinh viên tạo ra',
  desc: 'Tổng hợp UGC từ sinh viên — video, story, reels — nội dung lan tỏa tự nhiên nhất',
  format: 'UGC · Multi-platform',
  color: '#f5c96a'
}];


export default function Slide18Media({ id, registerRef }: Props) {
  return (
    <SlideWrapper id={id} registerRef={registerRef} className="bg-[#0f2318]">
      <div className="absolute inset-0">
        <img
          src="https://img.rocket.new/generatedImages/rocket_gen_img_159396fa0-1777290550411.png"
          alt="Người quay phim chụp ảnh thiên nhiên ngoài trời, sản xuất nội dung truyền thông xanh chân thực"
          className="w-full h-full object-cover opacity-10" />

        <div className="absolute inset-0 bg-gradient-to-b from-[#0f2318] via-[#1a3a2a]/30 to-[#0f2318]" />
        <div className="absolute top-1/3 right-0 w-[450px] h-[450px] rounded-full bg-[rgba(232,160,48,0.04)] blur-3xl" />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-16 xl:px-24 py-24 pt-28 min-h-screen flex flex-col justify-center">
        <div className="fade-in-up mb-4">
          <div className="chapter-badge amber">Truyền thông & hình ảnh</div>
        </div>

        <div className="fade-in-up mb-3">
          <h2 className="font-display font-800 text-[clamp(28px,4.5vw,56px)] leading-[1.1] text-[#f0ede6] tracking-tight">
            Nội dung thật —
          </h2>
          <h2 className="font-display font-800 text-[clamp(28px,4.5vw,56px)] leading-[1.1] tracking-tight text-gradient-amber">
            cảm xúc thật
          </h2>
        </div>

        <div className="fade-in-up mb-12">
          <div className="w-[60px] h-[3px] bg-gradient-to-r from-[#e8a030] to-[#f5c96a] rounded-full" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 fade-in-up">
          {mediaItems.map((item, i) =>
          <div
            key={`media-${i}`}
            className="rounded-2xl p-6 lg:p-7 flex items-start gap-5 transition-all duration-300 hover:-translate-y-1"
            style={{
              background: `linear-gradient(135deg, ${item.color}0f 0%, ${item.color}04 100%)`,
              border: `1px solid ${item.color}22`
            }}>

              <div
              className="p-3 rounded-xl flex-shrink-0"
              style={{ background: `${item.color}18` }}>

                {item.icon}
              </div>
              <div className="flex-1">
                <div className="flex items-start justify-between gap-3 mb-2">
                  <h3 className="font-display font-700 text-[16px] lg:text-[17px] text-[#f0ede6]">{item.title}</h3>
                  <span
                  className="text-[10px] font-600 px-2 py-0.5 rounded-full flex-shrink-0 font-body whitespace-nowrap"
                  style={{ background: `${item.color}18`, color: item.color }}>

                    {item.format}
                  </span>
                </div>
                <p className="font-body text-[13px] lg:text-[14px] text-[#a0b8a8] leading-relaxed">{item.desc}</p>
              </div>
            </div>
          )}
        </div>

        <div className="fade-in-up mt-8 glass-card p-5 lg:p-6">
          <div className="flex flex-col sm:flex-row items-center gap-4 text-center sm:text-left">
            <div className="flex gap-3 flex-shrink-0">
              {['TikTok', 'Instagram', 'Facebook', 'YouTube'].map((platform) =>
              <span
                key={`platform-${platform}`}
                className="text-[11px] font-600 px-3 py-1.5 rounded-full bg-[rgba(76,175,125,0.12)] border border-[rgba(76,175,125,0.2)] text-[#4caf7d] font-body">

                  {platform}
                </span>
              )}
            </div>
            <p className="font-body text-[14px] text-[#a0b8a8]">
              Nội dung được tối ưu cho đa nền tảng — nhà trường chỉ cần đăng, không cần chỉnh sửa
            </p>
          </div>
        </div>
      </div>
    </SlideWrapper>);

}